import { useState } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import _ from 'lodash';

import { SquareSwatch } from './SquareSwatch';
import { darkenColor } from '../../utils/colors';

/**
 * options: array of { name: string, value: string }
 * selected: {name: string, value: string}
 */
export const ColorDropdown = ({ options, value, onSelect, readonly }) => {
  const [isOpen, setIsOpen] = useState(false);

  const name = options.find((o) => o.value === value)?.name;
  const darkenedValue = darkenColor(value);

  if (readonly) {
    return (
      <div className="d-flex align-items-center">
        <SquareSwatch color={value} borderColor={darkenedValue} />
        <div className="ml-1">{_.capitalize(name)}</div>
      </div>
    );
  }

  return (
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen((o) => !o)}>
      <div className="d-flex align-items-center">
        <DropdownToggle color="light" size="sm" className="p-1">
          <SquareSwatch color={value} borderColor={darkenedValue} />
        </DropdownToggle>

        <div className="ml-1">{_.capitalize(name)}</div>
      </div>

      <DropdownMenu container="body" flip={false}>
        <DropdownItem key="header" header>
          Colors
        </DropdownItem>
        {options.map((color) => (
          <DropdownItem key={color.value} onClick={() => onSelect(color.value)}>
            <div className="d-flex align-items-center">
              <SquareSwatch
                color={color.value}
                borderColor={darkenColor(color.value)}
                className="mr-2"
              />
              <span>{_.capitalize(color.name)}</span>
            </div>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
